import { useTranslation } from "react-i18next";
import Grid from "../../config/Grid/Grid";
import styles from "./Summary.module.scss";
import TransparentTile from "../../components/TransparentTile/TransparentTile";
import Button from "../../components/Button/Button";
import OtherPaymentComponent from "./components/OtherPaymentComponent/OtherPaymentComponent";
import { useVenuesDataStore } from "@/store/useVenuesDataStore";
import { useParams } from "react-router-dom";

function Summary() {
  const { t } = useTranslation();
  const { restaurantId } = useParams();
  const {
    selectedAmount,
    remainingAmount,
    paidGuests = [],
    tipAmount,
  } = useVenuesDataStore();

  const paidAll = remainingAmount === 0;
  const shareUrl = `${window.location.origin}/restaurants/${restaurantId}`;

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: t("summary.title"),
          url: shareUrl,
        });
      } catch (error) {
        console.error("Share failed:", error);
      }
    } else {
      navigator.clipboard.writeText(shareUrl);
      alert("Link copied to clipboard!");
    }
  };

  return (
    <Grid>
      <div className={`start-1 col-4 ${styles.summaryWrapper}`}>
        <div className={styles.summaryHeader}>
          <p className={`body-bold-large ${styles.summaryTitle}`}>
            {t("summary.title")}
          </p>
        </div>
        <div className={styles.summaryContent}>
          <TransparentTile>
            <div className={styles.summaryContentHeader}>
              <p className={`body-medium ${styles.summaryDescription}`}>
                {t("summary.header.title")}
              </p>
              <p className={`headline-large ${styles.summaryPrice}`}>
                {(selectedAmount + tipAmount).toFixed(2)} zł
              </p>
            </div>
          </TransparentTile>
          <div className={styles.summaryContentBody}>
            {paidAll ? (
              <p className={`body-medium ${styles.summaryPaidMessage}`}>
                {t("summary.body.paidMessage")}
              </p>
            ) : (
              <div className={styles.summaryLeftToPayContainer}>
                <div className={styles.summaryLeftToPayHeader}>
                  <p className={`title-large ${styles.summaryLeftToPayTitle}`}>
                    {t("summary.body.leftToPay")}
                  </p>
                  <p className={`title-large ${styles.summaryLeftToPayPrice}`}>
                    {(remainingAmount / 100).toFixed(2)} zł
                  </p>
                </div>
                <Button
                  onClick={handleShare}
                  label={t("summary.body.shareButton")}
                  variant="contained"
                  color="primary"
                  maxWidth
                  mobile={true}
                  icon="las la-external-link-alt icon-medium"
                  iconLocation="right"
                />
                {paidGuests.length > 0 && (
                  <div className={`${styles.summaryOtherPaymentsContainer}`}>
                    <p
                      className={`body-medium ${styles.summaryOtherPaymentsTitle}`}
                    >
                      {t("summary.body.otherPayments")}
                    </p>
                    {paidGuests.map((guest) => {
                      const guestTotal = guest.dishes.reduce(
                        (sum, dish) =>
                          sum +
                          (dish.size?.price ?? dish.price) +
                          (dish.toppings?.reduce(
                            (s, topping) => s + topping.price,
                            0,
                          ) ?? 0),
                        0,
                      );
                      return (
                        <OtherPaymentComponent
                          key={guest.guestNumber}
                          text={`${t("summary.body.somebodyPaid")} - ${t("billsPage.summary.guest")} ${guest.guestNumber}`}
                          price={`${(guestTotal / 100).toFixed(2)} zł`}
                        />
                      );
                    })}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </Grid>
  );
}

export default Summary;
